export default __webpack_public_path__ + "static/media/warrantyManagement4.b36f0e1b.png";